import React from 'react'
import { Checkbox, DetailInfo } from '@softwaredev_cegeka/stix-form'
import { Tabs } from '@softwaredev_cegeka/stix-core'
import BaseSearchableList from 'src/components/SearchableList'
import { authenticatedUserStore } from 'src/stores'

const USER_TAB_MAPPINGS = {
    TENANTS_TAB: {
        entityName: 'tenant',
        dataField: 'tenants',
        itemId: 'tenant',
        itemDisplay: item => `${item.tenant_name} (${item.tenant})`,
        selectDisplay: item => `${item.name} (${item.organization_id})`,
    },
    SUPPLIER_TAB: {
        entityName: 'supplier',
        dataField: 'suppliers',
        itemId: 'id',
        itemDisplay: item => item.name,
        selectDisplay: item => item.name,
    },
    GROUP_TAB: {
        entityName: 'group',
        dataField: 'groups',
        itemId: 'id',
        itemDisplay: item => `${item.name} (${item.tenant_name})`,
        selectDisplay: item => `${item.name} (${item.tenant.name})`,
    },
}

/**
 * User Drawer content
 * @returns {*[]}
 */
export default function UserDrawerContent(
    user,
    addUserToGroup,
    unlinkUserFromGroup,
    addUserToTenant,
    unlinkUserFromTenant
) {
    const getSwitchProps = column => ({
        srOnly: true,
        type: 'switch',
        disabled: true,
        checked: !!user[column],
    })

    const content = [
        {
            label: 'Email',
            value: user.email,
        },
        {
            label: 'Locked',
            value: (
                <Checkbox {...getSwitchProps('locked')} label="Global admin" />
            ),
        },
        {
            label: 'Global admin',
            value: (
                <Checkbox
                    {...getSwitchProps('is_global_admin')}
                    label="Global admin"
                />
            ),
        },
        {
            label: 'Local user',
            value: (
                <Checkbox
                    {...getSwitchProps('is_local_user')}
                    label="Local user"
                />
            ),
        },
    ]

    const getUserOrganization = () => {
        if (authenticatedUserStore.selectedOrganization) {
            return authenticatedUserStore.selectedOrganization.id
        } else {
            const tenants = authenticatedUserStore.userOrganizations
            for (let i = 0; i < tenants.length; i++) {
                if (
                    tenants[i].organization_id ===
                    authenticatedUserStore.userData.organization_id
                ) {
                    return tenants[i].id
                }
            }
        }
    }

    const getGroupListItemLink = item => {
        const searchParams = new URLSearchParams({
            groupId: item.id,
            search: item.name,
        })
        return searchParams.toString()
    }

    return (
        <>
            <DetailInfo data={content} />
            <Tabs
                variant="material"
                defaultActiveKey="tenants"
                id="user-drawer-content-tabs"
            >
                <Tabs.Pane eventKey="tenants" title="Tenants">
                    <BaseSearchableList
                        data={user}
                        type={USER_TAB_MAPPINGS.TENANTS_TAB}
                        addEntityMethod={addUserToTenant}
                        removeEntityMethod={unlinkUserFromTenant}
                        confirmationMessage={`Are you sure you want to remove ${user.first_name} ${user.last_name} from tenant`}
                        filteredEntitiesUrl={'/api/auth/tenants'}
                        emptyListMessage={`No ${USER_TAB_MAPPINGS.TENANTS_TAB.entityName} linked to this user.`}
                        sortParam={{ sort: '+name' }}
                    />
                </Tabs.Pane>

                <Tabs.Pane eventKey="groups" title="Groups">
                    <BaseSearchableList
                        data={user}
                        type={USER_TAB_MAPPINGS.GROUP_TAB}
                        addEntityMethod={addUserToGroup}
                        filteredEntitiesUrl={
                            '/api/auth/tenants/' +
                            getUserOrganization() +
                            '/groups'
                        }
                        removeEntityMethod={unlinkUserFromGroup}
                        confirmationMessage={`Are you sure you want to remove ${user.first_name} ${user.last_name} from group`}
                        emptyListMessage={`No ${USER_TAB_MAPPINGS.GROUP_TAB.entityName} linked to this user.`}
                        sortParam={{ sort: '+name' }}
                        listItemUrl={{
                            pathname: '/groups',
                            search: getGroupListItemLink,
                        }}
                    />
                </Tabs.Pane>

                {/* Invert the outcome of the disabled check, because the string comparison results
                in true if the functionality is available and as an effect of that disables the tab, which we don't want
                in this case */}
                <Tabs.Pane
                    eventKey="suppliers"
                    title="Suppliers"
                    disabled={
                        !(
                            process.env
                                .REACT_APP_ENABLE_SUPPLIER_FUNCTIONALITY ===
                            'true'
                        )
                    }
                >
                    <BaseSearchableList
                        data={user}
                        type={USER_TAB_MAPPINGS.SUPPLIER_TAB}
                        emptyListMessage={`No ${USER_TAB_MAPPINGS.SUPPLIER_TAB.entityName} linked to this user.`}
                        sortParam={{ sort: '+name' }}
                    />
                </Tabs.Pane>
            </Tabs>
        </>
    )
}
